<template>
  <div>
    <div v-if="!value.isHideCountBar" class="count-box">
      预约 <span class="count-number">{{ value.student_count || 0 }}</span> 人，
      试课 <span class="count-number">{{ value.trial_count || 0 }}</span> 人，
      签到 <span class="primary-color count-number sign-in-count">{{ value.signed_count || 0 }}</span> 人
    </div>
    <div v-if="value.students" class="student-list-box">
      <router-link
        class="student-box primary-color"
        v-for="student in value.students"
        :key="`student-item-${student.id}`"
        :to="studentDetailTo(student.student_id || student.id)"
      >
        <v-avatar :value="student.selfie" :size="72" :class="avatarBorder(student)"/>
        <div :class="`nickname${student.stores ? ' primary-nickname' : ' '}${student.is_sign_other_course ? ' danger-color' : ''}`">
          {{ student.student_name }}
        </div>

        <template v-if="student.stores">
          <div v-for="(count, storeName) in student.stores" :key="`course-item-${storeName}-${student.id}`" class="nickname other-store-count accent-color" @click.prevent>{{ storeName }} {{ count }} 节</div>
        </template>
        <template v-else>
          <template v-if="student.reserve_state === reserveStates.waitSignIn.value">
            <div v-if="student.is_new" class="new-tip success-background">NEW</div>

            <div v-if="student.we_chat_order_id" class="time-limit-card success-background">微信支付待签到</div>
            <template v-else>
              <template v-if="student.card_ticket_id || student.is_number_limit">
                <div
                  v-if="!student.is_new && student.decrement_number > 100"
                  class="new-tip number-limit-card-background"
                >{{ student.decrement_number | toYuan }}次</div>
                <div v-if="student.card_id" class="time-limit-card number-limit-card-background">次卡待签到</div>
                <div v-else class="time-limit-card success-background">课券待签到</div>
              </template>
              <div v-else-if="!value.decrement_number" class="time-limit-card success-background">免费待签到</div>
              <div v-else class="time-limit-card time-limit-card-background" :title="student.card_name">
                <span class="ellipsis" v-if="student.card_id">通卡待签到</span>
                <template v-else>试课待签到</template>
              </div>
            </template>
          </template>
          <template v-else>
            <div v-if="student.is_new" class="new-tip success-background">NEW</div>

            <div v-if="student.we_chat_order_id" class="time-limit-card card-ticket-sign">微信支付签到</div>
            <template v-else>
              <template v-if="student.card_ticket_id || student.is_number_limit">
                <div
                  v-if="!student.is_new && student.decrement_number > 100"
                  class="new-tip card-sign-number"
                >{{ student.decrement_number | toYuan }}次</div>
                <div v-if="student.card_id" class="time-limit-card card-sign-number">次卡签到</div>
                <div v-else class="time-limit-card card-ticket-sign">课券签到</div>
              </template>
              <div v-else-if="!value.decrement_number" class="time-limit-card success-background">免费体验</div>
              <template v-else>
                <div v-if="student.card_id" class="time-limit-card card-sign-time" :title="student.card_name">
                  <span class="ellipsis">通卡签到</span>
                </div>
                <div v-else class="time-limit-card card-ticket-sign" :title="student.card_name">试课签到</div>
              </template>
            </template>
          </template>
          <div :class="`detail-box detail-box-${cardTypeColor(student)}`">
            <div>
              <span class="detail-student-name">{{ student.student_name }}</span>
              <span :class="`sign-state-box ${cardTypeBackground(student)}`">{{ getReservationShortNameByState(student.reserve_state) }}</span>
            </div>
            <router-link
              class="pay-type-link"
              :to="payTypeLink(student)"
            >
              <div :class="`${cardTypeColor(student)}`">{{ payType(student) }}</div>
              <div v-if="!student.is_new" :class="`expire-state${student.is_be_expire ? ' danger-color' : ' color-tip'}`">{{ student.expire_state }}</div>
            </router-link>
          </div>
        </template>
      </router-link>
    </div>
  </div>
</template>

<script>
import RouteConfig from "@/router/config";
import {  getReservationShortNameByState, reserveStates } from "@/enums/reserveStates";

export default {
  props: {
    value: Object,
  },
  data: () => ({
    reserveStates,
    studentDetailTo: RouteConfig.studentDetail.to,
  }),
  methods: {
    getReservationShortNameByState,
    avatarBorder(student) {
      if (student.is_sign_other_course) return 'danger-avatar';
      if (student.card_id && !student.is_number_limit) return 'card-time-avatar';
    },
    cardTypeBackground(student) {
      let payType = 'card-ticket-sign';
      if (student.card_id) payType =  student.is_number_limit ? 'card-sign-number' : 'card-sign-time';
      return `${payType}${student.reserve_state === reserveStates.waitSignIn.value ? '-highlight' : ''}`;
    },
    cardTypeColor(student) {
      if (student.card_id) return student.is_number_limit ? 'card-number-color' : 'card-time-color';
      return 'card-ticket-color';
    },
    payType(student) {
      if (student.card_id) return student.card_name || '课卡';
      if (student.card_ticket_id) return student.card_ticket_type_name || '课次券';
      if (student.we_chat_order_id) return '微信支付';
      if (student.decrement_number) return '免费体验';
    },
    payTypeLink(student) {
      if (student.card_id) return RouteConfig.cardDetail.to(student.card_id);
      if (student.card_ticket_id) return RouteConfig.cardTicketDetail.to(student.card_ticket_id);
      if (student.out_trade_no) return RouteConfig.weChatOrderList.to(null, { keyword: student.out_trade_no });
      return this.$route.fullPath;
    },
  }
};
</script>

<style scoped src="./index.css"/>
